module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1141.c86719d4.png";